import IChangePasswordState from '../models/IChangePasswordState';

export const initialState: IChangePasswordState= {
    success:false,
    error: null,
	loading: false
};